// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3RsI9eYRck4NpntqzmAYdZ_0","content":"_3zDMkVO5-dbrhT3zbAyJWY_0","menu":"_1NIbALkrohRylLE03iZeDO_0","chosen":"_3Gun01TNH5PfIy2AwisL3d_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f521cc8","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/router/Report.vue
// module id = X6bO
// module chunks = 1